import initVueApp from "@/core.js";
const component = require(`./../views/BlogStyleSeries.vue`).default;
initVueApp(component);
